import { render, staticRenderFns } from "./VerandaPanels.vue?vue&type=template&id=543dd400"
import script from "./VerandaPanels.vue?vue&type=script&lang=ts"
export * from "./VerandaPanels.vue?vue&type=script&lang=ts"
import style0 from "./VerandaPanels.vue?vue&type=style&index=0&id=543dd400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports